import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../buttons/Button'
import MoneyExchangeModal from './MoneyExchangeModal'
import { selectHasAnyItemsInCart } from '../../../../redux/selector/cart'
import { useDispatch, useSelector } from 'react-redux'
import { getActiveStatusForNewCashBookThunk } from '../../../../redux/thunk/cashBookNew'
import EnterFirstBalanceModal from './EnterFirstBalanceModal'

const MoneyExchange = React.memo(({ module, giftCoupons }) => {
	const { t } = useTranslation()
	const [showModal, setShowModal] = useState(false)
	const hasAnyItemInCart = useSelector(selectHasAnyItemsInCart(module))
	const conditionForDisabled = hasAnyItemInCart || giftCoupons?.length
	const dispatch = useDispatch()
	const [modalType, setModalType] = useState('MONEY_EXCHANGE_MODAL')

	const openModal = useCallback(async () => {
		const result = await dispatch(getActiveStatusForNewCashBookThunk())
		setModalType(result ? 'MONEY_EXCHANGE_MODAL' : 'ENTER_FIRST_BALANCE_MODAL')
		setShowModal(true)
	}, [dispatch])

	const closeModal = useCallback(() => {
		setShowModal(false)
	}, [])

	const handleShowMoneyExchangeModal = useCallback(() => {
		setModalType('MONEY_EXCHANGE_MODAL')
	}, [])

	return (
		<>
			<Button name="moneyExchange"
							testId="moneyExchange"
							color="blue"
							icon="money-exchange"
							text={t('Cart.MoneyExchange.title')}
							onClick={openModal}
							showTextForTablet={false}
							size="small"
							disabled={conditionForDisabled} />

			{modalType === 'MONEY_EXCHANGE_MODAL' && (
				<MoneyExchangeModal isOpen={showModal}
														close={closeModal}
														module={module} />
			)}
			{modalType === 'ENTER_FIRST_BALANCE_MODAL' && (
				<EnterFirstBalanceModal showModal={showModal}
																setShowModal={closeModal}
																handleShowMoneyExchangeModal={handleShowMoneyExchangeModal} />
			)}
		</>
	)
})

MoneyExchange.displayName = 'MoneyExchange'
export default MoneyExchange
